module.exports = __webpack_public_path__ + "static/media/marker-pin.272c44f1.svg";